import Modal from './template';
export default Modal;
